<template>
  <v-pagination
    v-show="pagination.pages > 1"
    v-model="curPage"
    :length="pagination.pages"
    prev-icon="mdi-arrow-left"
    next-icon="mdi-arrow-right">
  </v-pagination>
</template>

<script>
import events from 'Store/events'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'users-pagination',
  computed: {
    ...mapGetters({ pagination: 'users/pagination' }),
    curPage: {
      get: function () {
        return this.pagination.curPage
      },
      set: function (val) {
        this.$emit('loading')
        this.pageLoad(val).catch(err => {
          events.pubError(`Failed to load users: ${err.type} (${err.exception})`)
          this.dbg(err)
        }).finally(() => {
          this.$emit('loading')
        })
      }
    }
  },
  methods: mapActions({ pageLoad: 'users/pageLoad' })
}
</script>

<style scoped>
</style>
